import React, { useState, useEffect } from 'react';

// --- تغییر مسیر ایمپورت‌ها به پوشه Subprogram ---
import Handbook from './Subprogram/Handbook'; 
import AboutUs from './Subprogram/AboutUs';   
import MainPage from './Subprogram/MainPage'; 
import News from './Subprogram/News';         
import LoginAdmin from './Subprogram/LoginAdmin'; 
import FreeDiscussion from './Subprogram/FreeDiscussion';

// --- API Configuration ---
// فرض بر این است که فایل‌های PHP در پوشه /api در هاست شما قرار دارند
const API_BASE = 'https://daneshesaze.com/api'; 

// --- داده‌های سایت (عمومی) ---
const siteData = {
    "layout": {
        "header": {
            "title": "دانش سازه",
            "logo": "https://daneshesaze.com/Logo.png"
        },
        "footer": {
            "email": "hor.khosravi@gmail.com",
            "address": "مازندران، بابل، خیابان شریعتی، دانشگاه صنعتی نوشیروانی بابل",
            "copyright": "© ۱۴۰۳ - تمام حقوق برای وبسایت دانش سازه محفوظ است."
        }
    }
};

// --- ICONS ---
const Icons = {
  Menu: ({ size = 24, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><line x1="4" y1="6" x2="20" y2="6"></line><line x1="4" y1="12" x2="20" y2="12"></line><line x1="4" y1="18" x2="13" y2="18"></line></svg>,
  X: ({ size = 24, className, onClick }) => <svg onClick={onClick} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>,
  ChevronLeft: ({ size = 20, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M15 19l-7-7 7-7" /></svg>,
  List: ({ size = 20, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>,
  Search: ({ size = 16, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>,
  Download: ({ size = 20, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path></svg>,
  Calendar: ({ size = 16, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>,
  Lock: ({ size = 20, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>,
  LogOut: ({ size = 20, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>,
  Edit: ({ size = 20, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>,
  Trash2: ({ size = 20, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>,
  User: ({ size = 20, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>,
  Check: ({ size = 20, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><polyline points="20 6 9 17 4 12"></polyline></svg>
};

export default function DanesheSazeApp() {
    // --- STATE ---
    const [activePage, setActivePage] = useState('home');
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    
    // --- AUTH STATE ---
    const [user, setUser] = useState(null);
    const [showAuthModal, setShowAuthModal] = useState(false);
    const [authMode, setAuthMode] = useState('login'); // 'login' or 'signup'
    const [authEmail, setAuthEmail] = useState('');
    const [authPassword, setAuthPassword] = useState('');
    const [authUsername, setAuthUsername] = useState(''); 
    const [authLoading, setAuthLoading] = useState(false);

    // --- EFFECTS ---
    
    useEffect(() => {
        document.title = "دانش سازه - مرجع تخصصی آموزش مهندسی";
        const existingFavicon = document.querySelector("link[rel*='icon']");
        if (existingFavicon) {
            existingFavicon.href = siteData.layout.header.logo;
        } else {
            const newFavicon = document.createElement('link');
            newFavicon.rel = 'icon';
            newFavicon.href = siteData.layout.header.logo;
            document.head.appendChild(newFavicon);
        }
    }, []);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [activePage]);

    // چک کردن وضعیت لاگین از LocalStorage
    useEffect(() => {
        const storedUser = localStorage.getItem('daneshesaze_user');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    // --- SECRET ADMIN ENTRY ---
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const zone = queryParams.get('zone');
        if (zone === 'admin-panel') {
            setActivePage('admin');
        }
    }, []);

    // --- HANDLERS ---
    const handleNav = (page) => {
        setActivePage(page);
        setMobileMenuOpen(false);
    };

    const handleAuth = async (e) => {
        e.preventDefault();
        setAuthLoading(true);

        try {
            // تعیین Endpoint بر اساس مود (لاگین یا ثبت نام)
            const endpoint = `${API_BASE}/users.php`;
            
            const payload = authMode === 'login' 
                ? { action: 'login', email: authEmail, password: authPassword }
                : { action: 'signup', email: authEmail, password: authPassword, full_name: authUsername };

            const response = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (data.success) {
                if (authMode === 'login') {
                    // ذخیره کاربر در LocalStorage
                    localStorage.setItem('daneshesaze_user', JSON.stringify(data.user));
                    setUser(data.user);
                    setShowAuthModal(false);
                    alert('با موفقیت وارد شدید.');
                } else {
                    alert('ثبت نام با موفقیت انجام شد. اکنون می‌توانید وارد شوید.');
                    setAuthMode('login'); // تغییر به حالت لاگین
                }
            } else {
                throw new Error(data.error || 'خطایی رخ داد');
            }
            
            if (authMode === 'login' && data.success) {
                setAuthEmail('');
                setAuthPassword('');
                setAuthUsername('');
            }
        } catch (error) {
            alert(error.message || 'خطا در ارتباط با سرور.');
            console.error(error);
        } finally {
            setAuthLoading(false);
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('daneshesaze_user');
        setUser(null);
        alert('با موفقیت خارج شدید');
    };

    // --- RENDER ---
    const renderHeader = () => (
        <header className="glass-header sticky top-0 z-50">
            <nav className="container mx-auto p-4 relative flex items-center justify-between min-h-[80px]">
                <button onClick={() => handleNav('home')} className="logo-neumorphic text-3xl font-bold text-blue-700 flex items-center gap-3 relative z-20">
                    <img src={siteData.layout.header.logo} alt="Logo" className="h-12 w-auto object-contain" onError={(e) => { e.target.style.display='none'; }} />
                    <span className="hidden md:inline">{siteData.layout.header.title}</span>
                </button>

                <div className="hidden md:flex items-center gap-2 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
                    {[
                        { id: 'home', label: 'صفحه اصلی' },
                        { id: 'articles', label: 'جزوات درسی' },
                        { id: 'notes', label: 'یادداشت‌ها' },
                        { id: 'forum', label: 'تالار گفت‌و‌گو' },
                        { id: 'about', label: 'درباره ما' }
                    ].map(item => (
                        <button key={item.id} onClick={() => handleNav(item.id)} className={`nav-neumorphic-btn text-gray-600 ${activePage === item.id ? 'active' : ''}`}>
                            {item.label}
                        </button>
                    ))}
                     <button onClick={() => document.getElementById('footer-section')?.scrollIntoView({ behavior: 'smooth' })} className="nav-neumorphic-btn text-gray-600">تماس با ما</button>
                </div>

                <div className="hidden md:flex items-center relative z-20">
                    {user ? (
                         <button onClick={handleLogout} className="nav-neumorphic-btn text-red-500 font-bold flex items-center gap-2">
                            <Icons.LogOut size={16} /> خروج ({user.full_name || 'کاربر'})
                        </button>
                    ) : (
                        <button onClick={() => setShowAuthModal(true)} className="nav-neumorphic-btn text-blue-600 font-bold flex items-center gap-2">
                            <Icons.User size={16} /> ورود / ثبت نام
                        </button>
                    )}
                </div>

                <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden text-gray-600 p-2 relative z-20">
                    {mobileMenuOpen ? <Icons.X /> : <Icons.Menu />}
                </button>
            </nav>

            {mobileMenuOpen && (
                <div className="md:hidden glass-header p-4 border-t border-slate-200/50 flex flex-col gap-2 relative z-10">
                     {[
                        { id: 'home', label: 'صفحه اصلی' },
                        { id: 'articles', label: 'جزوات درسی' },
                        { id: 'notes', label: 'یادداشت‌ها' },
                        { id: 'forum', label: 'تالار گفت‌و‌گو' },
                        { id: 'about', label: 'درباره ما' }
                    ].map(item => (
                        <button key={item.id} onClick={() => handleNav(item.id)} className={`text-right py-2 text-gray-600 hover:text-blue-600 ${activePage === item.id ? 'text-blue-600 font-bold' : ''}`}>
                            {item.label}
                        </button>
                    ))}
                    <div className="border-t border-gray-300 my-2"></div>
                     {user ? (
                        <button onClick={handleLogout} className="text-right py-2 text-red-500 font-bold">خروج از حساب</button>
                     ) : (
                        <button onClick={() => { setShowAuthModal(true); setMobileMenuOpen(false); }} className="text-right py-2 text-blue-600 font-bold">ورود / ثبت نام</button>
                     )}
                </div>
            )}
        </header>
    );

    const renderFooter = () => (
        <footer id="footer-section" className="bg-slate-800/95 backdrop-blur-lg text-slate-300 mt-16 pt-12 pb-6">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
                    <div className="md:col-span-2">
                        <h4 className="text-2xl font-bold text-white mb-4">{siteData.layout.header.title}</h4>
                        <p className="text-sm text-slate-400 max-w-md">مرجع تخصصی آموزش مهندسی عمران، تحلیل سازه و طراحی لرزه‌ای.</p>
                    </div>
                    <div>
                        <h5 className="text-lg font-semibold text-white mb-4">دسترسی سریع</h5>
                        <ul className="space-y-2 text-sm">
                            <li><button onClick={() => handleNav('home')} className="hover:text-white transition-colors">همه‌ی دوره‌ها</button></li>
                            <li><button onClick={() => handleNav('articles')} className="hover:text-white transition-colors">جزوات درسی</button></li>
                            <li><button onClick={() => handleNav('notes')} className="hover:text-white transition-colors">یادداشت‌ها</button></li>
                        </ul>
                    </div>
                    <div>
                        <h5 className="text-lg font-semibold text-white mb-4">تماس با ما</h5>
                        <ul className="space-y-2 text-slate-400 text-sm">
                            <li>ایمیل: {siteData.layout.footer.email}</li>
                            <li>آدرس: {siteData.layout.footer.address}</li>
                        </ul>
                    </div>
                </div>
                <div className="border-t border-slate-700 pt-6 text-center text-slate-500 text-sm flex flex-col md:flex-row justify-between items-center gap-4">
                    <p>{siteData.layout.footer.copyright}</p>
                </div>
            </div>
        </footer>
    );

    if (activePage === 'admin') {
        return (
            <div dir="rtl" className="antialiased font-vazir min-h-screen bg-[#f0f0f3] text-[#334155]">
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Vazirmatn:wght@400;500;700;900&display=swap');
                    body { font-family: 'Vazirmatn', sans-serif; }
                    .glass-card { border-radius: 30px; background: linear-gradient(145deg, #e6d8d8, #ffffff); box-shadow: 17px 17px 34px #b8adad, -17px -17px 34px #ffffff; border: none; }
                    .shadow-neu { box-shadow: 17px 17px 34px #b8adad, -17px -17px 34px #ffffff; }
                    .shadow-neu-inset { box-shadow: inset 5px 5px 10px #bebebe, inset -5px -5px 10px #ffffff; }
                    .custom-scrollbar::-webkit-scrollbar { width: 6px; }
                    .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
                    .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
                `}</style>
                <LoginAdmin onBack={() => handleNav('home')} Icons={Icons} apiBase={API_BASE} />
            </div>
        );
    }

    return (
        <div dir="rtl" className="antialiased font-vazir min-h-screen bg-[#f0f0f3] text-[#334155]">
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Vazirmatn:wght@400;500;700;900&display=swap');
                body { font-family: 'Vazirmatn', sans-serif; }
                
                /* Neumorphism Utilities */
                .glass-card { border-radius: 53px; background: linear-gradient(145deg, #e6d8d8, #ffffff); box-shadow: 17px 17px 34px #b8adad, -17px -17px 34px #ffffff; border: none; transition: all 0.3s ease; }
                .glass-card:hover { box-shadow: inset 17px 17px 34px #b8adad, inset -17px -17px 34px #ffffff; transform: translateY(2px); }
                .glass-header { background: #f0f0f3; box-shadow: 5px 5px 10px #bebebe, -5px -5px 10px #ffffff; }
                .nav-neumorphic-btn { padding: 0.5rem 1.25rem; border-radius: 20px; background: #f0f0f3; box-shadow: 5px 5px 10px #bebebe, -5px -5px 10px #ffffff; transition: all 0.3s ease; }
                .nav-neumorphic-btn:hover, .nav-neumorphic-btn.active { box-shadow: inset 5px 5px 10px #bebebe, inset -5px -5px 10px #ffffff; color: #2563EB; transform: translateY(1px); }
                .logo-neumorphic { padding: 0.5rem 1rem; border-radius: 25px; background: #f0f0f3; box-shadow: 5px 5px 10px #bebebe, -5px -5px 10px #ffffff; transition: all 0.3s ease; }
                .logo-neumorphic:hover { box-shadow: inset 5px 5px 10px #bebebe, inset -5px -5px 10px #ffffff; transform: scale(0.98); }
                .shadow-neu { box-shadow: 17px 17px 34px #b8adad, -17px -17px 34px #ffffff; }
                .shadow-neu-sm { box-shadow: 5px 5px 10px #bebebe, -5px -5px 10px #ffffff; }
                .shadow-neu-inset { box-shadow: inset 5px 5px 10px #bebebe, inset -5px -5px 10px #ffffff; }
                .custom-scrollbar::-webkit-scrollbar { width: 6px; }
                .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
                .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
                
                /* --- FLIP CARD & DEEP STYLES RESTORED --- */
                .flip-card { background-color: transparent; perspective: 1000px; cursor: pointer; height: 340px; }
                .flip-card-inner { 
                    position: relative; width: 100%; height: 100%; text-align: center; 
                    transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s ease; 
                    transform-style: preserve-3d; 
                    border-radius: 53px; 
                    box-shadow: 17px 17px 34px #b8adad, -17px -17px 34px #ffffff;
                }
                .flip-card.flipped .flip-card-inner { transform: rotateY(180deg); }
                .flip-card-front, .flip-card-back { 
                    position: absolute; width: 100%; height: 100%; 
                    -webkit-backface-visibility: hidden; backface-visibility: hidden; -moz-backface-visibility: hidden; 
                    border-radius: 53px; 
                    overflow: hidden; 
                    background: linear-gradient(145deg, #e6d8d8, #ffffff);
                    border: none;
                    transition: box-shadow 0.3s ease;
                }
                .flip-card:hover .flip-card-inner { box-shadow: none; }
                .flip-card:hover .flip-card-front { box-shadow: inset 17px 17px 34px #b8adad, inset -17px -17px 34px #ffffff; }
                .flip-card-front { z-index: 2; transform: rotateY(0deg); }
                .flip-card-back { 
                    background: linear-gradient(145deg, #ffffff, #e6d8d8); 
                    color: #1e293b; transform: rotateY(180deg); 
                    display: flex; flex-direction: column; justify-content: center; align-items: center; 
                    z-index: 1; 
                }
                
                .platform-btn { 
                    display: flex; align-items: center; gap: 0.5rem; padding: 0.75rem 1.5rem; 
                    border-radius: 20px; font-weight: bold; transition: all 0.2s; width: 80%; justify-content: center; margin-bottom: 0.75rem; text-decoration: none; 
                    box-shadow: 5px 5px 10px #bebebe, -5px -5px 10px #ffffff;
                    background: #f0f0f3;
                    border: none;
                }
                .platform-btn:hover { 
                    transform: scale(1.05); 
                    box-shadow: inset 5px 5px 10px #bebebe, inset -5px -5px 10px #ffffff;
                }

                .download-link-item {
                    display: flex; justify-content: space-between; align-items: center; padding: 1rem 1.25rem;
                    background: #f0f0f3; border-radius: 20px;
                    box-shadow: inset 5px 5px 10px #bebebe, inset -5px -5px 10px #ffffff;
                    transition: all 0.2s ease-in-out;
                }
                .download-link-item:hover {
                    transform: translateY(-2px);
                    box-shadow: 5px 5px 10px #bebebe, -5px -5px 10px #ffffff;
                    background: linear-gradient(145deg, #e6d8d8, #ffffff);
                }
                
                .course-nav-btn:hover {
                    background: #f0f0f3;
                    box-shadow: inset 5px 5px 10px #bebebe, inset -5px -5px 10px #ffffff;
                    padding-right: 1.5rem;
                }
                .course-nav-btn.active {
                    background: #f0f0f3;
                    box-shadow: inset 5px 5px 10px #bebebe, inset -5px -5px 10px #ffffff;
                }

                /* Animations */
                @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
                .animate-fadeIn { animation: fadeIn 0.5s ease-out forwards; }
                
                @keyframes fadeInScale {
                    from { opacity: 0; transform: scale(0.98) translateY(10px); }
                    to { opacity: 1; transform: scale(1) translateY(0); }
                }
                .animate-fadeInScale { animation: fadeInScale 0.4s ease-out forwards; }
            `}</style>

            {renderHeader()}
            
            <main className="min-h-screen pt-4">
                {activePage === 'home' && <MainPage />}
                {activePage === 'articles' && <Handbook />}
                {activePage === 'notes' && <News Icons={Icons} apiBase={API_BASE} />}
                {activePage === 'forum' && <FreeDiscussion user={user} onShowAuth={() => setShowAuthModal(true)} Icons={Icons} apiBase={API_BASE} />}
                {activePage === 'about' && <AboutUs />}
            </main>

            {/* --- Global Auth Modal --- */}
            {showAuthModal && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/40 backdrop-blur-sm" onClick={() => setShowAuthModal(false)}>
                    <div onClick={e => e.stopPropagation()} dir="ltr">
                         <style>{`
                            @import url('https://fonts.googleapis.com/css?family=Raleway:400,700');
                            
                            .screen {       
                                background: linear-gradient(90deg, #5D54A4, #7C78B8);       
                                position: relative; 
                                height: 600px;
                                width: 360px;   
                                box-shadow: 0px 0px 24px #5C5696;
                                border-radius: 30px;
                                overflow: hidden;
                            }
                            .screen__content {
                                z-index: 1;
                                position: relative; 
                                height: 100%;
                            }
                            .screen__background {       
                                position: absolute;
                                top: 0;
                                left: 0;
                                right: 0;
                                bottom: 0;
                                z-index: 0;
                                clip-path: inset(0 0 0 0);  
                            }
                            .screen__background__shape {
                                transform: rotate(45deg);
                                position: absolute;
                            }
                            .screen__background__shape1 {
                                height: 520px;
                                width: 520px;
                                background: #FFF;   
                                top: -50px;
                                right: 120px;   
                                border-radius: 0 72px 0 0;
                            }
                            .screen__background__shape2 {
                                height: 220px;
                                width: 220px;
                                background: #6C63AC;    
                                top: -172px;
                                right: 0;   
                                border-radius: 32px;
                            }
                            .screen__background__shape3 {
                                height: 540px;
                                width: 190px;
                                background: linear-gradient(270deg, #5D54A4, #6A679E);
                                top: -24px;
                                right: 0;   
                                border-radius: 32px;
                            }
                            .screen__background__shape4 {
                                height: 400px;
                                width: 200px;
                                background: #7E7BB9;    
                                top: 420px;
                                right: 50px;    
                                border-radius: 60px;
                            }
                            .login {
                                width: 320px;
                                padding: 30px;
                                padding-top: 100px; /* Adjusted for close button space */
                            }
                            .login__field {
                                padding: 20px 0px;  
                                position: relative; 
                            }
                            .login__icon {
                                position: absolute;
                                top: 30px;
                                color: #7875B5;
                                left: 0; 
                            }
                            .login__input {
                                border: none;
                                border-bottom: 2px solid #D1D1D4;
                                background: none;
                                padding: 10px;
                                padding-left: 24px;
                                font-weight: 700;
                                width: 75%;
                                transition: .2s;
                                color: #333; 
                                font-family: 'Vazirmatn', sans-serif;
                            }
                            .login__input:active,
                            .login__input:focus,
                            .login__input:hover {
                                outline: none;
                                border-bottom-color: #6A679E;
                            }
                            .login__submit {
                                background: #fff;
                                font-size: 14px;
                                margin-top: 30px;
                                padding: 16px 20px;
                                border-radius: 26px;
                                border: 1px solid #D4D3E8;
                                text-transform: uppercase;
                                font-weight: 700;
                                display: flex;
                                align-items: center;
                                width: 100%;
                                color: #4C489D;
                                box-shadow: 0px 2px 2px #5C5696;
                                cursor: pointer;
                                transition: .2s;
                                justify-content: space-between;
                                font-family: 'Vazirmatn', sans-serif;
                            }
                            .login__submit:active,
                            .login__submit:focus,
                            .login__submit:hover {
                                border-color: #6A679E;
                                outline: none;
                                transform: scale(1.02);
                            }
                            .button__icon {
                                font-size: 24px;
                                margin-left: auto;
                                color: #7875B5;
                            }
                            .social-login { 
                                position: absolute;
                                height: 140px;
                                width: 100%;
                                text-align: center;
                                bottom: 0px;
                                right: 0px;
                                color: #fff;
                                display: flex;
                                align-items: flex-end;
                                justify-content: center;
                                padding-bottom: 20px;
                            }
                            .switch-btn {
                                color: white;
                                font-size: 14px;
                                cursor: pointer;
                                opacity: 0.8;
                                text-decoration: none;
                                font-family: 'Vazirmatn', sans-serif;
                                transition: 0.3s;
                                background: none;
                                border: none;
                                display: flex;
                                align-items: center;
                                gap: 8px;
                            }
                            .switch-btn:hover {
                                opacity: 1;
                                font-weight: bold;
                            }
                            /* Close button specific styling for this modal context */
                            .close-modal-btn {
                                position: absolute;
                                top: 20px;
                                right: 20px;
                                color: #6C63AC;
                                background: white;
                                border-radius: 50%;
                                padding: 5px;
                                box-shadow: 0 2px 5px rgba(0,0,0,0.1);
                                z-index: 10;
                                cursor: pointer;
                                transition: 0.2s;
                            }
                            .close-modal-btn:hover {
                                transform: scale(1.1);
                            }
                        `}</style>
                        
                        <div className="screen">
                            <button className="close-modal-btn" onClick={() => setShowAuthModal(false)}>
                                <Icons.X size={20} />
                            </button>

                            <div className="screen__content">
                                <form className="login" onSubmit={handleAuth}>
                                    {authMode === 'signup' && (
                                        <div className="login__field">
                                            <div className="login__icon">
                                                <Icons.User size={18} />
                                            </div>
                                            <input 
                                                type="text" 
                                                className="login__input" 
                                                placeholder="نام و نام خانوادگی" 
                                                value={authUsername}
                                                onChange={(e) => setAuthUsername(e.target.value)}
                                                style={{ textAlign: 'right', paddingRight: '24px', paddingLeft: '10px' }}
                                            />
                                        </div>
                                    )}

                                    <div className="login__field">
                                        <div className="login__icon">
                                            <Icons.User size={18} /> {/* Using User icon for email/general ID as in admin panel */}
                                        </div>
                                        <input 
                                            type="email" 
                                            className="login__input" 
                                            placeholder="ایمیل" 
                                            value={authEmail}
                                            onChange={(e) => setAuthEmail(e.target.value)}
                                            style={{ textAlign: 'right', paddingRight: '24px', paddingLeft: '10px' }}
                                        />
                                    </div>

                                    <div className="login__field">
                                        <div className="login__icon">
                                            <Icons.Lock size={18} />
                                        </div>
                                        <input 
                                            type="password" 
                                            className="login__input" 
                                            placeholder="رمز عبور" 
                                            value={authPassword}
                                            onChange={(e) => setAuthPassword(e.target.value)}
                                            style={{ textAlign: 'right', paddingRight: '24px', paddingLeft: '10px' }}
                                        />
                                    </div>

                                    <button type="submit" className="login__submit" disabled={authLoading}>
                                        <span className="button__text">{authLoading ? '...' : (authMode === 'login' ? 'ورود به سایت' : 'ثبت نام')}</span>
                                        <Icons.ChevronLeft className="button__icon" size={24} style={{ transform: 'rotate(180deg)' }} />
                                    </button>
                                </form>
                                
                                <div className="social-login">
                                    <button 
                                        onClick={() => setAuthMode(authMode === 'login' ? 'signup' : 'login')}
                                        className="switch-btn"
                                    >
                                        {authMode === 'login' 
                                            ? 'حساب ندارید؟ ثبت نام کنید' 
                                            : 'قبلاً ثبت نام کردید؟ وارد شوید'}
                                    </button>
                                </div>
                            </div>
                            <div className="screen__background">
                                <span className="screen__background__shape screen__background__shape4"></span>
                                <span className="screen__background__shape screen__background__shape3"></span>     
                                <span className="screen__background__shape screen__background__shape2"></span>
                                <span className="screen__background__shape screen__background__shape1"></span>
                            </div>      
                        </div>
                    </div>
                </div>
            )}

            {renderFooter()}
        </div>
    );
}